module.exports = __webpack_public_path__ + "static/Ubuntu-BoldItalic-48c161df9991f9b0f6e4a858e95e415e.ttf";